import { store, ReactNotificationOptions } from 'react-notifications-component';

export const NotifyTypeSuccess = 'success';
export const NotifyTypeDanger = 'danger';

export const createNotify = (
  message: string | React.ReactNode | React.FunctionComponent,
  type?: ReactNotificationOptions['type'],
) => {
  store.addNotification({
    message,
    type: type || NotifyTypeSuccess,
    insert: 'top',
    container: 'top-right',
    dismiss: {
      duration: 3000,
      onScreen: false,
    },
  });
};
